<template>
  <div>
    <search-table
      ref="searchTable"
      :columnMove="false"
      :columns="syncTableProperties"
      :data="openTableData"
      :need-pagination="false"
      :showSummary="true"
      :needAllColumnSummary="true"
      :tableRowKey="'id'"
      @getTableData="getTableData"
    >
          <template #stff_name="scope">
        {{ scope.row.stff_name || '-' }}
      </template>
      <template #detailAction="scope">
        <el-link type="primary" @click="openDetail(scope.row)">详情</el-link>
      </template>
    </search-table>
    <processStatisticsDialog
      :visible.sync="detailDialogVisible"
      :module="module"
      :stffName="searchFormStffName"
      :startTime="daytime && daytime[0]"
      :endTime="daytime && daytime[1]"
    />
  </div>
</template>

<script>
import SearchTable from '@/components/SearchTableV3.vue';
import ProcessStatisticsDialog from '@/views/DataStatistics/ProductValueYieldStatisticsYangZhou/TabChild/ProcessStatisticsDialog';

export default {
  components: { SearchTable, ProcessStatisticsDialog },
  props: ['tableData', 'allTableData', 'module', 'daytime'],
  name: 'Open',
  data() {
    return {
      syncTableProperties: [
        { label: '员工姓名', prop: 'employee_name', itemType: 'input', input: true, sortable: false, widthAuto: true },
        { label: '新款款数', prop: 'new_style_count', itemType: 'input', input: false, sortable: true, widthAuto: true },
        { label: '新款片数', prop: 'new_piece_count', itemType: 'input', input: false, sortable: true, widthAuto: true },
        { label: '修改款数', prop: 'modify_style_count', itemType: 'input', input: false, sortable: true, widthAuto: true },
        { label: '修改片数', prop: 'modify_piece_count', itemType: 'input', input: false, sortable: true, widthAuto: true },
        { label: '老款款数', prop: 'old_style_count', itemType: 'input', input: false, sortable: true, widthAuto: true },
        { label: '老款片数', prop: 'old_piece_count', itemType: 'input', input: false, sortable: true, widthAuto: true },
        { label: '样品数量', prop: 'sample_count', itemType: 'input', input: false, sortable: true, widthAuto: true },
        { label: '详情', prop: 'detailAction', itemType: 'input', input: false, sortable: false, widthAuto: true, invisible: false }
      ],
      detailDialogVisible: false,
      currentRow: {}
    };
  },
  computed: {
    openTableData() {
      setTimeout(() => {
        this.$refs.searchTable.$refs.multiTable.doLayout();
      }, 0);
      return this.tableData;
    },
    searchFormStffName() {
      return this.currentRow.employee_name || null;
    }
  },
  methods: {
    toTimeDay(time) {
      return this.helper.toTimeDay(time);
    },
    getTableData() {
      this.$emit('getTableData', this.getSearchForm());
    },
    openDetail(row) {
      this.currentRow = row;
      this.detailDialogVisible = true;
    },
    getSearchForm() {
      return this.$refs.searchTable?.searchForm;
    },
    resetFields() {
      this.$refs.searchTable?.resetFields();
    }
  }
};
</script>

<style scoped></style>
